import { render, staticRenderFns } from "./inspection-patients.page.vue?vue&type=template&id=8d0525c6"
import script from "./inspection-patients.page.vue?vue&type=script&lang=js"
export * from "./inspection-patients.page.vue?vue&type=script&lang=js"
import style0 from "./inspection-patients.page.vue?vue&type=style&index=0&id=8d0525c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports